<div class="row">
    <div class="col-xl-12">
        <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" (reset)="onReset()">
            <table class="table mb-0 table-bordered table-borderless create-evse">
                <tbody class="border-none">
                    <tr>
                        <td>
                            Type<span class="text-danger h5 ml-2"><sup>*</sup></span>
                        </td>
                        <td>
                            <!-- <kendo-dropdownlist #typeList [data]="types" [defaultItem]="defaultType" [textField]="'display'" [valueField]="'value'" formControlName="resetType">
                            </kendo-dropdownlist> -->

                            <p-dropdown class="mr-2" #typeList formControlName="resetType" appendTo="body"
                            [options]="types" optionValue="value" optionLabel="display">
                            </p-dropdown>

                            <br>
                            <span class="text-danger pt-2 float-left" *ngIf="(resetForm.controls.resetType.touched || submitted) && resetForm.controls.resetType.errors?.required">
                              Type  is required.
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Reason<span class="text-danger h5 ml-2"><sup>*</sup></span>
                        </td>
                        <td>
                            <input type="text" formControlName="reason" class="form-control" />
                            <span class="text-danger pt-2 float-left" *ngIf="(resetForm.controls.reason.touched || submitted) && resetForm.controls.reason.errors?.required">
                              Reason  is required.
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="mt-3 text-center">
                            <div class="d-inline">
                                <input type="submit" class="btn btn-hes mr-3" value="Run Action">
                                <input type="reset" class="btn btn-danger" value="Cancel">
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>
    </div>
</div>
